import React, { useState } from 'react';
import { View, StyleSheet } from 'react-native';
import { withTranslation } from 'react-i18next';
import { Tabs, Tab } from '../../ui';
import { Planner } from './Planner';
import { WorkoutHistoryScreen } from '../../WorkoutHistory';

interface IWorkoutsTabNavigationProps {
  navigation: any;
  user: any;
  t: (key: string) => string;
}

const WorkoutsTabNavigationComponent: React.FunctionComponent<IWorkoutsTabNavigationProps> = (props) => {
  const [activeTab, setActiveTab] = useState(0);
  const { t } = props;

  const renderTabContent = () => {
    switch (activeTab) {
      case 0:
        return <Planner {...props} />;
      case 1:
        return <WorkoutHistoryScreen {...props} />;
      default:
        return <Planner {...props} />;
    }
  };

  return (
    <View style={styles.container}>
      <Tabs>
        <Tab
          active={activeTab === 0}
          title={t('Schedule')}
          onPress={() => setActiveTab(0)}
          currentTabIndex={0}
          useDarkTheme={false}
        />
        <Tab
          active={activeTab === 1}
          title={t('History')}
          onPress={() => setActiveTab(1)}
          currentTabIndex={1}
          useDarkTheme={false}
        />
      </Tabs>
      <View style={styles.contentContainer}>
        {renderTabContent()}
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
  },
  contentContainer: {
    flex: 1,
  },
});

export const WorkoutsTabNavigation = withTranslation(['workoutHistory'])(WorkoutsTabNavigationComponent);
